<template>
  <el-image v-bind="$attrs">
    <template slot="placeholder"><slot name="placeholder" /></template>
    <template slot="error"><slot name="error" /></template>
  </el-image>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'PreviewImage',
  inheritAttrs: false,
});
</script>
